import React, { useState, useEffect } from "react";
import "./organizationalchart.css";
import Title from "../../components/title";
import { faChartDiagram, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Modal, Button, Row, Col, Image } from "react-bootstrap";
import { Row, Col, Image, Modal, Button } from "react-bootstrap";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";

const ProfileModal = ({ show, handleClose, person }) => {
  if (!person) return null;

  const defaultAvatar = "https://via.placeholder.com/150";

  return (
    <Modal
      className="dir"
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      dir="rtl"
    >
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <Modal.Title>
          <FontAwesomeIcon icon={faChartDiagram} className="ms-2" />
          {"profile"}: {person.name}
        </Modal.Title>
        <Button
          className="custom-close-button"
          variant="link"
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faXmark} className="closeModal" />
        </Button>
      </Modal.Header>
      <Modal.Body className="dir">
        <Row>
          <Col md={4} className="text-center">
            <Image
              src={person.photo || defaultAvatar}
              roundedCircle
              fluid
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                border: "3px solid var(--border-color)",
              }}
              alt={person.name}
            />
            <h4 className="mt-3">{person.name}</h4>
            <p className="text-muted">
              {person.job_number ? `${"job_number"}: ${person.job_number}` : ""}
            </p>
          </Col>
          <Col md={8}>
            <h5>{"basic-info"}</h5>
            <hr />
            <p>
              <strong>{"email"}:</strong> {person.email || "not-available"}
            </p>
            <p>
              <strong>{"phone"}:</strong> {person.phone || "not-available"}
            </p>
            <p>
              <strong>{"address"}:</strong> {person.address || "not-available"}
            </p>
            <p>
              <strong>{"joining-date"}:</strong>{" "}
              {person.date_of_joining || "not-available"}
            </p>
            <p>
              <strong>{"qualification"}:</strong>{" "}
              {person.qualification || "not-available"}
            </p>
            <p>
              <strong>{"marital-status"}:</strong>{" "}
              {person.marital_status === "single"
                ? "Single"
                : person.marital_status === "married"
                ? "Married"
                : person.marital_status === "divorced"
                ? "Divorced"
                : person.marital_status === "widowed"
                ? "Widowed"
                : "not-available"}
            </p>

            <h5 className="mt-4">{"financial-info"}</h5>
            <hr />
            <p>
              <strong>{"total-salary"}:</strong>{" "}
              {person.total_salary
                ? `${Number(
                    person.total_salary
                  ).toLocaleString()} ${"currency"}`
                : "not-available"}
            </p>
            <p>
              <strong>{"bank-account-number"}:</strong>{" "}
              {person.bank_account_number || "not-available"}
            </p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center align-items-center">
        <Button variant="secondary" onClick={handleClose}>
          {"close"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const PersonCard = ({ person, isManager = false, onClick }) => {
  return (
    <div
      className={`person-card ${isManager ? "manager" : ""}`}
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      {isManager && (
        <div className="role-badge">
          <i className="fa-solid fa-crown"></i> {"manager"}
        </div>
      )}
      <div className="avatar">
        {person.photo ? (
          <img
            src={person.photo}
            alt={person.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />
        ) : (
          <i className="fa-solid fa-user"></i>
        )}
      </div>
      <div className="person-name">{person.name}</div>
      <div className="person-role">
        {isManager ? "department-manager" : "employee"}
      </div>
    </div>
  );
};

function OrganizationalChart() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);

  const handleShowModal = (person) => {
    setSelectedPerson(person);
    setShowModal(true);
  };

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleOpenModal = (emp) => {
    setSelectedEmployee(emp);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEmployee(null);
  };



   

  
  
  const [data, setData] = useState([]);
  const getChart = async () => {
    try {
      const response = await API.get(`/jobtitle/organiztionchart`);
      setData(response.data);
      setLoading(false);

    } catch (error) {
      setLoading(true);
      console.error("خطأ في جلب البيانات:", error);
    }
  };

  useEffect(() => {
    getChart();
  }, []);
  
  

  


  return (
    loading ? 
      <TestPreLoader />
     : 
    <div className="org-chart-container">
      <Title
        title={"company-organizational-chart"}
        icon={<FontAwesomeIcon icon={faChartDiagram} />}
      />
      <div className="departments-wrapper">
        {data.map((dept) => (
          <div key={dept.uuid} className="department-card">
            <div className="department-header">
              <h2>{dept.name}</h2>
            </div>

            {dept.manager ? (
              <div className="manager-section">
                <PersonCard
                  person={dept.manager}
                  isManager={true}
                  onClick={() => handleShowModal(dept.manager)}
                />
              </div>
            ) : (
              <p
                style={{
                  textAlign: "center",
                  color: "#a7a7d1",
                  margin: "20px 0",
                }}
              >
                {"no-manager"}
              </p>
            )}
            <div className="employees-grid">
              {dept.employees && dept.employees.length > 0 ? (
                dept.employees.map((employee) => (
                  <PersonCard
                    key={employee.uuid}
                    person={employee}
                    onClick={() => handleShowModal(employee)}
                  />
                ))
              ) : (
                <p
                  style={{
                    color: "#a7a7d1",
                    gridColumn: "1 / -1",
                    textAlign: "center",
                  }}
                >
                  {"no-employees"}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      {selectedPerson && (
        <ProfileModal
          show={showModal}
          handleClose={handleCloseModal}
          person={selectedPerson}
        />
      )}
    </div>
  );
}

export default OrganizationalChart;
